import Image from 'next/image';
import { cn } from '@/lib/utils';

type BrandLogoTone = 'dark' | 'light';

interface BrandLogoProps {
  /** Show only the purple mark, no wordmark */
  markOnly?: boolean;
  /** `dark` = dark text (light backgrounds), `light` = white text (dark backgrounds) */
  tone?: BrandLogoTone;
  className?: string;
  /** Size of the square mark in px */
  markSize?: number;
  priority?: boolean;
}

/**
 * Transparent purple mark + live-text wordmark.
 * No dark plate — sits cleanly on any background.
 */
const BrandLogo = ({
  markOnly = false,
  tone = 'dark',
  className,
  markSize = 36,
  priority = false,
}: BrandLogoProps) => {
  const mark = (
    <span
      className="relative block shrink-0"
      style={{ width: markSize, height: markSize }}
    >
      <Image
        src="/Nens_mark.png"
        alt="Nens Informatics"
        fill
        priority={priority}
        sizes={`${markSize}px`}
        className="object-contain"
        unoptimized
      />
    </span>
  );

  if (markOnly) {
    return <span className={cn('inline-flex', className)}>{mark}</span>;
  }

  return (
    <span className={cn('inline-flex items-center gap-2.5', className)}>
      {mark}
      <span className="flex flex-col leading-none">
        <span
          className={cn(
            'font-display text-[0.95em] font-bold tracking-tight',
            tone === 'light' ? 'text-white' : 'text-foreground'
          )}
        >
          Nens
        </span>
        <span
          className={cn(
            'font-sans text-[0.62em] font-medium tracking-[0.18em] uppercase',
            tone === 'light' ? 'text-white/70' : 'text-text-secondary'
          )}
        >
          Informatics
        </span>
      </span>
    </span>
  );
};

export default BrandLogo;
